<template>
    <div class="main-line">
        <div id="lineCharts"></div>
    </div>
</template>

<script>
    import dateTool from "@/utils/dateTool";
    import handleData from "@/utils/handleData.js";
    export default {
        name:"cdcbLine",
        props:{
            selectedMeasure:{
                type:Object,
                default:{
                    measureId: "",
                    measureName: ""
                }
            },
            timeElem:{
                type:Object,
                default:()=>{}
            }
        },
        data(){
            return{
                myChartLine:null,
                pointCode:"100229",
                pointNumber:"0"
            }
        },
        methods: {
            async getData(){
                let [changetype,tempwitch,conbackpro] = ["HH时","0",undefined];
                let mpidarr = [{measureId:this.selectedMeasure.measureId,pointNumber:this.pointNumber, pointCode:this.pointCode}];
                if(this.timeElem.dateType == "day"){
                    conbackpro = this.$api.quantity.getQuantitySumHour(mpidarr,this.timeElem.startTime,this.timeElem.endTime,"0");
                    changetype = "H时";
                    tempwitch = "0";
                }else if(this.timeElem.dateType == "month"){
                    conbackpro = this.$api.quantity.getQuantitySumDay(mpidarr,this.timeElem.startTime,this.timeElem.endTime,"0");
                    changetype = "d日";
                    tempwitch = "2";
                }else{
                    conbackpro = this.$api.quantity.getQuantitySumMonth(mpidarr,this.timeElem.startTime,this.timeElem.endTime,"0");
                    changetype="M月";
                    tempwitch="5";
                }
                conbackpro.then(res=>{
                    let resdata=res.data;
                    this.changeXdata(changetype,resdata);
                    let temp = handleData.createXData(tempwitch,this.timeElem.startTime,this.timeElem.endTime);
                    let tempx=[],tempy=[];
                    temp.forEach(res=>{
                        res.value='-';
                        resdata.forEach(item=>{
                            if(res.title==item.time){
                                res.value=item.value?item.value.toFixed(2):"-";
                            }
                        })
                        tempx.push(res.title);
                        tempy.push(res.value);
                    })
                    this.showLine(tempx,tempy);
                })
            },
            showLine(xdata,ydata){
                if (this.myChartLine != null && this.myChartLine != "" && this.myChartLine != undefined) {
                    this.myChartLine.dispose();
                }
                this.myChartLine = this.$echarts.init(document.getElementById("lineCharts"));
                var option = {
                        tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    grid: {
                        left: "2%",
                        right: "2%",
                        bottom: "3%",
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        data: xdata
                    },
                    yAxis: {
                        type: 'value',
                        name: 'kWh',
                    },
                    series: [{
                        data: ydata,
                        type: 'line'
                    }]
                };
                this.myChartLine.setOption(option, true);
                window.addEventListener("resize",() => {
                    if (this.myChartLine) {
                        this.myChartLine.resize();
                    }
                });
            },
            changeXdata(changetype,arr){
                arr.filter(res=>{
                    res.time = dateTool.format(new Date(new Date(res.time).getTime()), changetype);
                })
            }
        },
    }
</script>

<style lang="scss" scoped>
    .main-line{
        background: #fff;width: 100%;height:100%;border-radius: 4px;box-sizing: border-box;overflow: hidden;padding: 10px;text-align: left;color: #333;
        #lineCharts{
            width: 100%;height: 100%;
        }
    }
</style>